"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.__fieldPosition = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
var _AnalyzePole = _interopRequireDefault(require("./AnalyzePole"));
var _ANSIData = require("./ANSIData");
var _damageValidator = require("./damageValidator");
var _poleSchema = _interopRequireWildcard(require("./poleSchema"));
var _SectionCalculator = require("./SectionCalculator");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var __fieldPosition = exports.__fieldPosition = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _SectionCalculator.TYPE_HEART, ["shellThickness"]), _SectionCalculator.TYPE_SHELL, ["damageDepth"]), _SectionCalculator.TYPE_POCKET, ["angleToMinShell", "pocketDiameter", "shellThickness"]), _SectionCalculator.TYPE_WEDGE, ["angleToDamage", "circumferenceMissing", "depthMissing"]), _SectionCalculator.TYPE_SECTION, ["angleToOpening", "depthMissing", "circumferenceMissing", "shellThickness"]), _SectionCalculator.TYPE_SLICE, ["angleToDamage", "depthMissing", "widthMissing"]), _SectionCalculator.TYPE_CAVITY, ["angleToOpening", "circumferenceMissing", "shellThicknessAtOpening", "nestDiameter"]), _SectionCalculator.TYPE_BOLT, ["angleToOpening", "holeDiameter"]);
var Pole = /*#__PURE__*/function () {
  function Pole(pole) {
    _classCallCheck(this, Pole);
    _defineProperty(this, "projectId", '');
    _defineProperty(this, "info", {});
    _defineProperty(this, "damageParameters", {});
    _defineProperty(this, "output", {});
    var today = (0, _moment["default"])().toISOString();
    var _ref = pole ? pole : _poleSchema["default"],
      info = _ref.info,
      damageParameters = _ref.damageParameters,
      output = _ref.output,
      projectId = _ref.projectId;
    var poleName = info.name;
    this.projectId = projectId ? projectId : '';
    poleName = poleName ? poleName : "Structure - ".concat(new Date(today).toDateString());
    this.info = _objectSpread(_objectSpread({}, info), {}, {
      name: poleName,
      date: today
    });
    this.damageParameters = damageParameters;
    this.output = output;
  }
  _createClass(Pole, [{
    key: "validate",
    value: function validate(pole) {
      var damageParameters = pole.damageParameters;
      for (var level in damageParameters) {
        var _validateSlice = (0, _damageValidator.validateSlice)(damageParameters[level]),
          isValid = _validateSlice.isValid;
        if (!isValid) return false;
      }
      return true;
    }
  }, {
    key: "importCsv",
    value: function importCsv(poleCsv) {
      this.validateImport(poleCsv, 'csv');
      var _poleCsv = _slicedToArray(poleCsv, 2),
        headers = _poleCsv[0],
        values = _poleCsv[1];
      return values.reduce(function (importedPole, parameter, i) {
        if (parameter === '' || parameter === undefined) return importedPole;
        var header = headers[i];
        var splitParams = header.split('_');
        importedPole['projectId'] = poleCsv[1][1];
        if (i < 13) {
          var infoMap = {
            'pole_name': 'name',
            'id': 'id',
            'date': 'date',
            'length': 'ansiLength',
            'species': 'ansiSpecies',
            'class': 'ansiClass',
            'isLinearTaper': 'isLinearTaper',
            'userEmbedment': 'userEmbedment',
            'fiberStrength': 'fiberStrength',
            'taper': 'ansiTaper',
            'embedment': 'ansiEmbedment',
            'ansi_dia': 'ansiDiameter'
          };
          var key = infoMap[headers[i]];
          if (parameter !== poleCsv[1][1]) {
            if (key === 'ansiSpecies') {
              var obj = _ANSIData.ansiSpeciesList.find(function (o) {
                return o.label === parameter;
              });
              importedPole.info[key] = {
                name: obj.label,
                id: obj.id
              };
            } else {
              if (key === 'ansiDiameter' || key === 'ansiLength' || key === 'userEmbedment' || key === 'fiberStrength') {
                parameter = parseInt(parameter);
              } else if (key === 'isLinearTaper') {
                if (parameter === 'true') {
                  parameter = true;
                }
              }
              importedPole.info[key] = parameter;
            }
          }
        } else if (i < 77) {
          var level = splitParams[0][1];
          var section = importedPole.damageParameters[level];
          var parameterName = header.slice(3);
          var parameterIsDamage = splitParams[1][0] === 'd';
          if (parameterName === 'diameter') {
            section.diameter = +parameter;
          } else if (parameterName === 'dist_from_groundline') {
            section.distanceFromGround = +parameter;
          } else if (parameterIsDamage) {
            var damageIndex = splitParams[1][1] - 1;
            var isType = header.indexOf('type') !== -1;
            if (isType) {
              section.damages[damageIndex] = {};
              section.damages[damageIndex].type = parameter.toUpperCase();
            } else {
              var paramIndex = header.slice(-1) - 1;
              var type = section.damages[damageIndex].type.toUpperCase();
              var fieldId = __fieldPosition[type][paramIndex];
              section.damages[damageIndex][fieldId] = +parameter;
            }
          }
        } else {
          var outputMap = {
            'area': 'area',
            'section_modulus_inline': 'momentSlopeY',
            'section_modulus_transverse': 'momentSlopeX',
            'moment_of_inertia_inline': 'momentInertiaY',
            'moment_of_inertia_transverse': 'momentInertiaX',
            'svg_string': 'svg'
          };
          var _level = header.slice(-1);
          var _section = importedPole.output[_level]['actual'];
          var paramName = header.slice(0, -3);
          var _key = outputMap[paramName];
          if (_key === 'svg') parameter = decodeURIComponent(parameter);else parameter = +parameter;
          if (_key) _section[_key] = parameter;
        }
        return importedPole;
      }, _objectSpread({}, _poleSchema["default"]));
    }
  }, {
    key: "validateImport",
    value: function validateImport(importedPole, type) {
      var isIncorrect = function isIncorrect() {
        throw new Error('Imported pole data is incorrect');
      };
      if (type === 'json') {
        var validateKeys = function validateKeys(poleSchema, importedPole) {
          for (var key in poleSchema) {
            if (importedPole.hasOwnProperty(key) && !_lodash["default"].isArray(poleSchema[key]) && _typeof(poleSchema[key]) === 'object') validateKeys(poleSchema[key], importedPole[key]);
            if (!importedPole.hasOwnProperty(key)) {
              isIncorrect();
            }
          }
        };
        validateKeys(_poleSchema["default"], importedPole);
        if (!this.validate(importedPole)) isIncorrect();
      } else if (type === 'csv') {
        var _importedPole = _slicedToArray(importedPole, 1),
          headers = _importedPole[0];
        headers.forEach(function (header, i) {
          return header !== _poleSchema.csvHeaders[i] && isIncorrect();
        });
      }
    }
  }, {
    key: "getCSVRowData",
    value: function getCSVRowData() {
      var projectId = this.projectId;
      var _this$info = this.info,
        name = _this$info.name,
        date = _this$info.date,
        id = _this$info.id,
        ansiLength = _this$info.ansiLength,
        ansiSpecies = _this$info.ansiSpecies,
        ansiClass = _this$info.ansiClass,
        isLinearTaper = _this$info.isLinearTaper,
        ansiTaper = _this$info.ansiTaper,
        ansiEmbedment = _this$info.ansiEmbedment,
        userEmbedment = _this$info.userEmbedment,
        fiberStrength = _this$info.fiberStrength,
        ansiDiameter = _this$info.ansiDiameter;
      var ansiSpeciesName = ansiSpecies.name;
      var csvData = [name, projectId, id, date, ansiLength, ansiSpeciesName, ansiClass, isLinearTaper, userEmbedment, fiberStrength, ansiTaper, ansiEmbedment, ansiDiameter];
      for (var level = 1; level <= 3; level++) {
        var _this$damageParameter = this.damageParameters[level],
          distanceFromGround = _this$damageParameter.distanceFromGround,
          diameter = _this$damageParameter.diameter,
          damages = _this$damageParameter.damages;
        csvData.push(diameter);
        csvData.push(diameter * Math.PI);
        csvData.push(distanceFromGround);
        var _loop = function _loop() {
          var damage = damages[i];
          var values = [undefined, undefined, undefined, undefined, undefined];
          if (damage) {
            Object.entries(damage).forEach(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                fieldId = _ref3[0],
                param = _ref3[1];
              if (fieldId === 'type') values[0] = param;else {
                var fieldIndex = __fieldPosition[damage.type].indexOf(fieldId) + 1;
                values[fieldIndex] = param;
              }
            });
          }
          csvData.push.apply(csvData, values);
        };
        for (var i = 0; i < 4; i++) {
          _loop();
        }
      }
      for (var _level2 = 1; _level2 <= 3; _level2++) {
        var computed = this.output[_level2]['actual'];
        if (!computed) {
          csvData.push(0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        } else {
          var area = computed.area,
            momentSlopeY = computed.momentSlopeY,
            momentSlopeX = computed.momentSlopeX,
            momentInertiaY = computed.momentInertiaY,
            momentInertiaX = computed.momentInertiaX;
          var _Analyze$calculatePer = new _AnalyzePole["default"](this.damageParameters[_level2]).calculatePercent(computed),
            polePercentSlopeY = _Analyze$calculatePer.polePercentSlopeY,
            polePercentSlopeX = _Analyze$calculatePer.polePercentSlopeX,
            polePercentArea = _Analyze$calculatePer.polePercentArea,
            polePercentMomentY = _Analyze$calculatePer.polePercentMomentY,
            polePercentMomentX = _Analyze$calculatePer.polePercentMomentX;
          csvData.push(area, polePercentArea, momentSlopeY, polePercentSlopeY, momentSlopeX, polePercentSlopeX, momentInertiaY, polePercentMomentY, momentInertiaX, polePercentMomentX);
        }
      }
      for (var _i = 1; _i <= 3; _i++) {
        if (this.output[_i]) {
          csvData.push(encodeURIComponent(this.output[_i].svg));
        } else {
          csvData.push('');
        }
      }
      return csvData;
    }
  }, {
    key: "exportCSV",
    value: function exportCSV() {
      var rows = [_poleSchema.csvHeaders, this.getCSVRowData()];
      var csvContent = rows.map(function (e) {
        return e.join(",");
      }).join("\n");
      return new Blob([csvContent], {
        type: 'text/csv'
      });
    }
  }, {
    key: "importJson",
    value: function importJson(json) {
      var importedPole = JSON.parse(json);
      this.validateImport(importedPole, 'json');
      for (var level = 1; level <= 3; level++) {
        var svg = importedPole.output[level].svg;
        importedPole.output[level].svg = decodeURIComponent(svg);
      }
      return importedPole;
    }
  }, {
    key: "getJSONData",
    value: function getJSONData() {
      return {
        projectId: this.projectId,
        info: this.info,
        output: this.output,
        damageParameters: this.damageParameters
      };
    }
  }, {
    key: "exportJson",
    value: function exportJson() {
      var jsonContent = JSON.stringify(this.getJSONData(), null, 2);
      return new Blob([jsonContent], {
        type: 'application/json'
      });
    }
  }]);
  return Pole;
}();
var _default = exports["default"] = Pole;